export default __webpack_public_path__ + "static/lady-on-phone-008bed34feb66a68997837962d6f0908.svg";